import './Notification.css';

const Notification = ({ notifications }) => {
  const removeNotification = (id) => {
    // Notification removal handled by parent component's timeout
  };

  if (!notifications.length) return null;

  return (
    <div className="notifications-container">
      {notifications.map((notification, index) => (
        <div
          key={notification.id}
          className="notification-item"
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          <div className="notification-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 5.5V7H9V5.5L3 7V9L5 9.5V15.5L3 16V18L9 16.5V18H15V16.5L21 18V16L19 15.5V9.5L21 9Z"/>
            </svg>
          </div>
          
          <div className="notification-content">
            <div className="notification-message">
              {notification.message}
            </div>
            <div className="notification-time">
              {notification.timestamp}
            </div>
          </div>
          
          <button 
            className="notification-close"
            onClick={() => removeNotification(notification.id)}
          >
            ×
          </button>
          
          <div className="notification-progress"></div>
        </div>
      ))}
    </div>
  );
};

export default Notification;